import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin, onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
import {
  DATADOG_ENV,
  DATADOG_SERVICE,
  DATADOG_SITE,
  DATADOG_VERSION,
} from '@/lib/datadog/constants';

export { onRouterTransitionStart };

const parseSampleRate = (v, def = 100) =>
  !v || isNaN(v) ? def : Math.min(100, Math.max(0, Number(v)));

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

// BL-520: without this, a missing env var means RUM silently never initialises —
// indistinguishable from "no errors happened". Name what is missing instead.
if (!applicationId || !clientToken) {
  const missing = [
    !applicationId && 'NEXT_PUBLIC_DATADOG_APPLICATION_ID',
    !clientToken && 'NEXT_PUBLIC_DATADOG_CLIENT_TOKEN',
  ].filter(Boolean);
  console.warn(`[Datadog] RUM not initialised. Missing: ${missing.join(', ')}`);
}

if (applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: DATADOG_ENV,
    version: DATADOG_VERSION,
    sessionSampleRate: parseSampleRate(process.env.NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE, 100),
    sessionReplaySampleRate: parseSampleRate(process.env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_SAMPLE_RATE, 20),
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [nextjsPlugin()],
  });
}

